import { createContext, Component } from 'react';
import type { ReactNode } from 'react';
import type * as Highcharts from 'highcharts';

interface WithTheme {
  theme: any;
}

export type SWSHighCharts = typeof Highcharts & WithTheme;

interface ContextType {
  highCharts: SWSHighCharts;
}
export const HighChartsContext = createContext<ContextType | null>(null);

interface Props {
  highCharts: SWSHighCharts;
  children: ReactNode;
}

class Provider extends Component<Props> {
  render() {
    const { highCharts, children } = this.props;
    return (
      <HighChartsContext.Provider value={{ highCharts }}>
        {children}
      </HighChartsContext.Provider>
    );
  }
}

export default Provider;
export const Consumer = HighChartsContext.Consumer;
